document.addEventListener('click', function(event) {
  // Find the closest .accordion-header ancestor (or itself) of the clicked element
  const header = event.target.closest('.accordion-header');

  // If no .accordion-header ancestor is found, exit the function
  if (!header) return;

  // Find the parent .accordion-item of the clicked header
  const item = header.closest('.accordion-item');

  // Select all accordion items
  const accordionItems = document.querySelectorAll('.accordion-item');

  accordionItems.forEach(otherItem => {
    if (otherItem !== item) {
      otherItem.classList.remove('active');
    }
  });

  // Toggle the 'active' class on the clicked item
  item.classList.toggle('active');
});
